import Typography, { TypographyProps } from "@mui/material/Typography";

export function ListItemText({ ...props }: Omit<TypographyProps, "component">) {
  return <Typography component={"span"} {...props} />;
}
